import React from "react";
import "./SubPageHeader.scss";
import {MDBBox, MDBModal, MDBModalBody, MDBTypography} from "mdbreact";
import {connect} from "react-redux";
import {withRouter} from 'react-router-dom'
import AddMoney from "../../pages/UserWallet/AddMoney";
import WithdrawMoney from "../../pages/UserWallet/WithdrawMoney";
import CashDetail from "../../pages/UserWallet/CashDetail";
import {assetUrl} from "../../serviceApi";
import {fetchQuery} from "relay-runtime";
import environment from "../../Environment";
import WalletDataQuery from "../../queries/WalletData";
import {NonEmptyArray} from "../../util";
import {
	addToHomeScreenModalToggler,
	addToHomeScreenToggler,
	addToHomescreenVisitChecker,
	AddWalletData,
	setActivePage, setLoginStep
} from "../../Actions";
import {compose} from "redux";
import Login from "../../pages/Login/Login";

const WalletIcon = assetUrl + "images/wallet.svg";
const NotificationIcon = assetUrl + "images/notification-icon.svg";
const NotificationIconEmpty = assetUrl + "images/Notifications-bell-empty-black.svg";
const ArrowLeft = assetUrl + "images/arrow-left.svg";

class SubPageHeader extends React.Component {
	state = {
		notification: [],
		currentModal: "",
		walletData: {},
		login_modal:false
	}
	setActiveModal = (args) => {
		this.setState({
			currentModal: args,
		})
	}

	componentDidMount() {
		if(this.props.logged_in){
			this.getWalletData();
		}
	}

	// used for related stock on politician/stock detail pg
	previousPgStockRedirector = () => {
		// if  - origin url and current page are not same
		if (this.props.origin_stock_id !== this.props.match.params.id) {
			// redirecting from "related" stock
			this.props.history.push("/stock-detail/" + this.props.origin_stock_id)
			// to avoid confusion ( infinite loop between "origin" and "related page")
			this.props.setOriginStockId("clear")
		} else {
			// redirecting from "origin" stock
			this.props.history.push("/all-stocks")
			this.props.setOriginStockId("")
		}

	}
	getWalletData = () => {
		let variables = {
			userId: this.props.user_details.user.id
		}
		// this.updateLoading(true);
		fetchQuery(environment, WalletDataQuery, variables)
			.toPromise()
			.then(response => {
				// this.updateLoading(false);
				if (NonEmptyArray(response.allWallet)) {
					// props.setWalletData(response.allWallet.edges[0].node);
					// this.setState({
					// 	walletData: response.allWallet.edges[0].node
					// })
					this.props.addWalletData(response.allWallet.edges[0].node)

				}
			}, err => {
				// this.updateLoading(false);
				console.log(err);
				// this.setState({
				// 	walletData: {}
				// })
				this.props.addWalletData({})

			});
	}
	openLoginModal = () => {
		this.setState({
			login_modal:true
		});
	}
	closeLoginModal = () => {
		this.setState({
			login_modal:false
		});
	}
	checkUserLoggedIn = (action) => {
		if(this.props.logged_in === false){
			this.openLoginModal();
		} else if(action === "wallet") {
			this.setState({currentModal: "cash"})
		} else if(action === "notification") {
			this.props.history.push("/notification")
		}
	}
	completeLogin = () => {
		this.closeLoginModal();
		// this.getWalletData();
		window.location.reload();
	}

	render() {
		return (
			<>
				<MDBBox className="sub-page-header-component d-flex justify-content-between align-items-center">
					<MDBBox className="d-flex align-items-center">
						<img src={ArrowLeft} alt={"ArrowLeft"} onClick={() => {
							// used for related stock on politician/stock detail pg
							this.props.hasPreviousStockPage && true ?
								this.previousPgStockRedirector()
								:
								this.props.history.goBack()
						}}/>
						<MDBTypography tag="p" className="title">{this.props.title}</MDBTypography>
					</MDBBox>
					{
						this.props.show_action === true &&
						<MDBBox className="d-flex align-items-center">
							<img src={WalletIcon} alt="WalletIcon"
								 className={"wallet-icon"}
								 onClick={()=>this.checkUserLoggedIn("wallet")}
								// onClick={() => this.setState({currentModal: "cash"})}
							/>
							<img src={this.state.notification.length > 0 ? NotificationIcon : NotificationIconEmpty}
								 alt="NotificationIcon"
								 className={"bell-icon"}
								 onClick={()=>this.checkUserLoggedIn("notification")}
								// onClick={() => this.props.history.push("/notification")}
							/>
						</MDBBox>
					}
					<MDBModal fullHeight={false} position="bottom" overflowScroll={true} inline={false}
							  noClickableBodyWithoutBackdrop={false} isOpen={this.state.currentModal !== ""}>
						<MDBModalBody>
							{
								this.state.currentModal === "add" ?
									<AddMoney
										setActiveModal={(args) => this.setActiveModal(args)}
										user_details={this.props.user_details}
									/> :
									this.state.currentModal === "withdraw" ?
										<WithdrawMoney
											setActiveModal={(args) => this.setActiveModal(args)}
											user_details={this.props.user_details}
										/> :
										this.state.currentModal === "cash" ?
											<CashDetail setActiveModal={(args) => {
												this.setActiveModal(args)
											}}/> :
											null
							}

						</MDBModalBody>
					</MDBModal>


				</MDBBox>
				<Login isOpen={this.state.login_modal}
					   closeModal={this.closeLoginModal}
					   completeLogin={this.completeLogin}
				/>
			</>

		);
	}
}

const mapStateToProps = state => ({
	user_details: state.UserReducer.user_details,
	logged_in: state.UserReducer.logged_in
});

const mapDispatchToProps = dispatch => ({

	addWalletData: data => dispatch(AddWalletData(data)),


})

export default connect(mapStateToProps,mapDispatchToProps)(withRouter(SubPageHeader));
